import type { ButtonHTMLAttributes, ReactNode } from "react";

interface ToolbarButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  children: ReactNode;
}

const ToolbarButton = ({
  label,
  children,
  className = "",
  ...props
}: ToolbarButtonProps) => {
  return (
    <div className="group relative flex items-center">
      <button {...props} aria-label={label} className={`bar-btn ${className}`}>
        {children}
      </button>

      <span
        role="tooltip"
        className="
          pointer-events-none
          invisible
          absolute
          bottom-full
          left-1/2
          z-[1000]
          mb-2
          -translate-x-1/2
          translate-y-1
          whitespace-nowrap
          rounded-md
          bg-gray-900
          px-2.5
          py-1.5
          text-xs
          font-medium
          text-white
          opacity-0
          transition-all
          duration-150
          group-hover:visible
          group-hover:translate-y-0
          group-hover:opacity-100
          group-hover:delay-300
        "
      >
        {label}
      </span>
    </div>
  );
};

export default ToolbarButton;
